export const THEME_COLOR = '#061a54';

export const GRAY_COLOR = '#8492a6';
